import { DropdownProps, MultiSelectProps, SingleSelectProps } from '../Dropdown';

export default function useDropdownSelection(props: DropdownProps) {
  const isMultiSelect = props.multiSelect;

  const singleProps = !isMultiSelect ? (props as SingleSelectProps) : null;
  const preSelectedOption = !isMultiSelect ? (singleProps?.preSelectedOption ?? null) : null;
  const singleSelectHandler = !isMultiSelect ? singleProps?.onSelect : undefined;

  const multiProps = isMultiSelect ? (props as MultiSelectProps) : null;
  const preSelectedOptions = isMultiSelect ? (multiProps?.preSelectedOptions ?? []) : [];
  const multiSelectHandler = isMultiSelect ? multiProps?.onSelect : undefined;

  return {
    preSelectedOption,
    preSelectedOptions,
    singleSelectHandler,
    multiSelectHandler,
  };
}
